<template>
  <Modal v-model="model" sticky reset-drag-position title="导入客户" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="import_pop">
    <div class="import_template">
      <div class="font_style_set">上传Excel文件:</div>
      <Upload :action="uploadUrl" :on-success="handleSuccess" :before-upload="beforeUpload" :on-error="handleFail" :on-progress="getProgress" :format="format" :on-format-error="handleFormatError">
        <Button icon="ios-cloud-upload-outline">文件上传</Button>
      </Upload>
    </div>
    <Progress :percent="percentage" v-if="percentage>0" :stroke-width="5"></Progress>
    <Progress status="wrong" v-if="percentage<0" :percent="99" :stroke-width="5"><span style="color:red;">失败</span></Progress>
    <div class="import_template">
      <div class="font_style_set">导入设置:</div>
      <CheckboxGroup v-model="type">
        <Checkbox label="1">
          <span>智能生成数据字典</span>
        </Checkbox>
        <Checkbox label="2">
          <span>过滤重复记录</span>
        </Checkbox>
        <Checkbox label="3">
          <span>覆盖重复数据</span>
        </Checkbox>
      </CheckboxGroup>
    </div>
    <div class="import_template_record">
      <div class="font_style_set">[智能生成数据字典]; 勾选表示: 导入的下拉框数据不存在关联的数据字典值会自动添加数据字典值,不勾选表示: 只会保存下拉框数据能够关联上的数据字典值</div>
      <div class="font_style_set">[过滤重复记录]; 勾选表示: 在导入EXCEL中数据时会过滤掉原有数据,不勾选表示: 1.号码允许重复时,则EXCEL中导入数据不会覆盖原有数据,直接新增。2.号码不允许重复时,则EXCEL中导入数据会覆盖原有数据。</div>
      <div class="font_style_set">[覆盖重复数据]; 勾选表示:表格导入数据存在冲突时,直接覆盖原有数据,以表格数据为准,不勾选表示:不会覆盖原有数据</div>
    </div>
    <div class="import_template">
        <div class="downLoad_file"><a :href="downUrl" target="_blank">下载Excel导入模板</a></div>
        <div class="downLoad_file" style="display:none;"><a target="_blank" :href="errorUrl" id="downErrorUrl">错误列表</a></div>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "ImportCustomerPop",
    mixins:[publicFunClass],
    props: {
      showImportPop:Boolean,
      uploadSign:String,
      customerState:String
    },
    data(){
      return {
        model:false,
        uploadType:'blob',
        type:[],
        percentage:0,
        format:['xls','xlsx'],
        // customerState 1 是公海客户  moduleId 1 客户模块 3 服务记录模块
        downUrl:this.baseURL+"common/downloadTemplate.json?companyId="+localStorage.getItem("companyId")+"&customerState="+this.customerState+"&moduleId=1",
        errorUrl:this.baseURL+"common/downloadFile.json?type=1",
        errorDownUrl:'',
        uploadUrl:"",
        baseUploadUrl:"",
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
      }
    },
    methods:{
      beforeUpload:function(res, file){
        console.log(file);
      },
      handleFormatError (file) {
        this.$Modal.info({
          title:'提示',
          content: '文件 ' + file.name + ' 格式不正确，请上传 xls 或 xlsx 格式的文件!'
        });
      },
      cancel:function(){
        this.$emit("closeImport",false);
      },
      getProgress(event){
        if(event.percent<99){
          this.percentage=parseInt(event.percent.toFixed(2));
        }
      },
      handleSuccess:function (res, file) {
        if(res.flag!="666"){
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          return false;
        }
        this.percentage=100;
        let that = this;
        if(file.response.obj && file.response.obj.url){
          that.errorUrl=this.baseURL+"common/downloadFile.json?type=1"+"&addr="+file.response.obj.url;
          document.getElementById('downErrorUrl').href = that.errorUrl;
          setTimeout(function () {
            document.getElementById("downErrorUrl").click();
          },2000);
        }
        setTimeout(function () {
          that.$emit("closeImport",true);
        },1000);
      },
      handleFail:function (error, file) {
        this.$Modal.info({
          title:'提示',
          content:res.msg
        });
        this.percentage=-10;
        if(file.response.obj.url){
          let that = this;
          that.errorUrl=this.baseURL+"common/downloadFile.json?type=1"+"&addr="+file.response.obj.url;
          setTimeout(function () {
            document.getElementById("downErrorUrl").click();
          },2000);
        }
      }
    },
    watch:{
      type:function(){
        this.uploadUrl=this.baseUploadUrl+"&type="+this.type.toString();
      },
      showImportPop:function () {
        this.model=this.showImportPop;
        
        this.percentage=0;
        this.baseUploadUrl=this.baseURL+"common/importCustomer.json?token="+localStorage.getItem("token")+"&module="+this.uploadSign;
        this.downUrl = this.baseURL+"common/downloadTemplate.json?companyId="+localStorage.getItem("companyId")+"&customerState="+this.uploadSign+"&moduleId=1",
        this.type=[];
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerMange/ImportCustomerPop.vue